import cn from 'classnames';
import { FC } from 'react';
import { AiOutlineClose } from 'react-icons/ai';
import { Link } from 'react-router-dom';
import { companySocialIcons, defaultSocialIcon } from '../../../../../../../helpers/icon-maps';
import { IconButton } from '../../../../../../../components/icon-button/icon-button';
import { InlineInputs } from '../../../../../../../components/inline-inputs/inline-inputs';
import s from './company-socials-input.module.css';
import { Input } from '../../../../../../../components/input/input';

interface Props {
  type: string;
  index: number;
  disabled?: boolean;
  url?: string;
  onChange?: (index: number, value: string) => void;
  onDelete?: (index: number) => void;
}

export const CompanySocialsInput: FC<Props> = ({
  url,
  type,
  index,
  disabled,
  onChange,
  onDelete,
}) => {
  let link = url || '';
  if (url) link = url.startsWith('https://') || url.startsWith('http://') ? url : `https://${url}`;

  const isRenderDelete = !companySocialIcons[type] && !!onDelete && !!url;

  return (
    <InlineInputs>
      <Link target="__blank" to={link} className={cn(!url && s.disabled)}>
        <IconButton disabled={!url} style={{ borderRadius: 'inherit' }}>
          {companySocialIcons[type] || defaultSocialIcon}
        </IconButton>
      </Link>
      <Input
        value={url}
        onChange={(e) => onChange?.(index, e.currentTarget.value)}
        disabled={disabled}
        size="md"
      />
      {isRenderDelete && (
        <IconButton
          onClick={() => onDelete?.(index)}
          size="md"
          variant="danger"
          disabled={disabled}
        >
          <AiOutlineClose />
        </IconButton>
      )}
    </InlineInputs>
  );
};
